import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import { Col, Row } from "antd";
import dayjs from "dayjs";

import { CommonDatePicker } from "../../CommonForms/CommonDatePicker";
import CommonButton from "../../Buttons/CommonButton";
import classes from "../Filter.module.css";
import Commontimepicker from "../../CommonForms/CommonTimePicker";
import { FilterValuesCheck } from "../../../Shared/Methods";

interface props {
  showfilter: boolean;
  GetList: (
    page?: any,
    size?: any,
    value?: any,
    isreset?: boolean,
    isDownload?: boolean,
    OrderBy?: string,
    Order?: string,
    // eb_power?: boolean,
    // dg_power?: false,
    // sump_status?: false,
    // borewell?: false,
    pin_1_status?: boolean,
    pin_2_status?: boolean,
    pin_3_status?: boolean,
    isAlert?: false,
    withtime?: any,
    communicationfailvalue?: boolean
  ) => void;
  pageSize: number;
  pageind: number;
  setpageSize: Dispatch<SetStateAction<number>>;
  setPageInd: Dispatch<SetStateAction<number>>;
  ResetForm: () => void;
  historyReport?: boolean;
  notificationReport?: boolean;
  typeList?: { label: string; value: string }[];
  setIsTime?: Dispatch<SetStateAction<boolean>>;
  isTime?: boolean;

  setIsChecked: Dispatch<SetStateAction<any>>;
  SetCheckedArray: Dispatch<SetStateAction<any>>;
  setIsAlert: Dispatch<SetStateAction<boolean>>;
  isChecked: any;
  CheckedArray: any;
  isAlert: boolean | any;
  AlphabetType: any;
  setAlphabetTyppe: any;
  currentdate: any;
  communicationfailvalue: boolean;
}

function Filterreadingreport({
  showfilter,
  GetList,
  pageSize,
  pageind,
  setpageSize,
  setPageInd,
  ResetForm,
  setIsTime,
  isTime,
  setIsChecked,
  SetCheckedArray,
  setIsAlert,
  isChecked,
  CheckedArray,
  isAlert,
  AlphabetType,
  setAlphabetTyppe,
  currentdate,
  communicationfailvalue,
}: props) {
  const [values, setvalues] = useState<any>({
    from_date: null,
    to_date: "",
  });

  useEffect(() => {
    setvalues({ ...values, from_date: currentdate });
  }, [currentdate]);

  const ChangeTimeout = () => {
    if (isTime && (values?.from_time || values?.to_time)) {
      let from = "";
      let to = "";

      if (values?.from_time) {
        let Time1 = dayjs(values?.from_time).format("HH:mm:ss");
        let date1 = values?.from_date
          ? dayjs(values?.from_date).format("YYYY-MM-DD")
          : dayjs(new Date()).format("YYYY-MM-DD");

        from = date1 + " " + Time1;
      }
      if (values?.to_time) {
        let Time2 = dayjs(values?.to_time).format("HH:mm:ss");
        let date2 = values?.to_date
          ? dayjs(values?.to_date).format("YYYY-MM-DD")
          : dayjs(new Date()).format("YYYY-MM-DD");

        // setFinaldate({ ...finaldate, to_date: date2 + " " + Time2 });
        to = date2 + " " + Time2;
      }

      GetList(
        1,
        pageSize,
        {
          from_date: from
            ? from
            : values?.from_date
            ? dayjs(values.from_date).format("YYYY-MM-DD 23:59:59")
            : "",
          to_date: to
            ? to
            : values.to_date
            ? dayjs(values.to_date).format("YYYY-MM-DD 00:00:00")
            : "",
        },
        false,
        false,
        AlphabetType?.OrderBy,
        AlphabetType?.Order,
        isChecked?.pin_1_status,
        isChecked?.pin_2_status,
        isChecked?.pin_3_status,
        isAlert,
        true,
        communicationfailvalue
      );

      setIsChecked(isChecked);
      SetCheckedArray(CheckedArray);
      setIsAlert(isAlert);
      setAlphabetTyppe(AlphabetType);
      if (setIsTime)
        setIsTime(values?.to_time || values?.from_time ? true : false);
    } else {
      GetList(
        1,
        pageSize,
        {
          from_date: values.from_date
            ? dayjs(values.from_date).format("YYYY-MM-DD 23:59:59")
            : "",
          to_date: values.to_date
            ? dayjs(values.to_date).format("YYYY-MM-DD 00:00:00")
            : "",
        },
        false,
        false,
        AlphabetType?.OrderBy,
        AlphabetType?.Order,
        // isChecked?.isEbchecked,
        // isChecked?.isDgchecked,
        // isChecked?.isSumpchecked,
        // isChecked?.IsBorewellchecked,
        isChecked?.pin_1_status,
        isChecked?.pin_2_status,
        isChecked?.pin_3_status,
        isAlert,
        false,
        communicationfailvalue
      );
      setIsChecked(isChecked);
      SetCheckedArray(CheckedArray);
      setIsAlert(isAlert);
      setAlphabetTyppe(AlphabetType);

      if (setIsTime)
        setIsTime(values?.to_time || values?.from_time ? true : false);
    }
  };

  return (
    <>
      {showfilter ? (
        <div className={classes.filter_container}>
          <Row gutter={[16, 16]}>
            <Col xl={4} lg={6} md={6} sm={12} xs={24}>
              <CommonDatePicker
                labelname="From Date"
                value={values.from_date}
                onChange={(data, dateString) => {
                  setvalues({
                    ...values,
                    from_date: data ? dayjs(data).format("YYYY-MM-DD") : "",
                  });
                }}
                size="large"
                name="from_date"
                FromDate={values.from_date}
                ToDate={values.to_date}
                DateType="from_date"
              />
            </Col>
            <Col xl={4} lg={6} md={6} sm={12} xs={24}>
              <Commontimepicker
                onChange={(time) => {
                  if (setIsTime) setIsTime(true);
                  setvalues({
                    ...values,
                    from_time: time,
                  });
                }}
                size="large"
                labelname="From Time"
                value={values.from_time}
                name="from_time"
                FromTime={values.from_time}
                ToTime={values.to_time}
                DateType="from_time"
                // onSelect={(value: any) => {
                //   if (setIsTime) setIsTime(true);
                //   setvalues({
                //     ...values,
                //     from_time: value,
                //   });
                // }}
              />
            </Col>
            <Col xl={4} lg={6} md={6} sm={12} xs={24}>
              <CommonDatePicker
                labelname="To Date"
                value={values.to_date}
                onChange={(data, dateString) => {
                  setvalues({
                    ...values,
                    to_date: data ? dayjs(data).format("YYYY-MM-DD") : "",
                  });
                }}
                size="large"
                name="to_date"
                ToDate={values.to_date}
                FromDate={values.from_date}
                DateType="to_date"
              />
            </Col>

            <Col xl={4} lg={6} md={6} sm={12} xs={24}>
              <Commontimepicker
                onChange={(time) => {
                  if (setIsTime) setIsTime(true);
                  setvalues({
                    ...values,
                    to_time: time,
                  });
                }}
                size="large"
                labelname="To Time"
                value={values.to_time}
                name="to_time"
                FromTime={values.from_time}
                ToTime={values.to_time}
                DateType="to_time"
                // onSelect={(value: any) => {
                //   if (setIsTime) setIsTime(true);
                //   setvalues({
                //     ...values,
                //     to_time: value,
                //   });
                // }}
              />
            </Col>
            <Col
              xl={4}
              lg={6}
              md={6}
              sm={12}
              xs={24}
              className="d-flex align-items-end"
            >
              <CommonButton
                name="Search"
                onClick={() => {
                  ChangeTimeout();
                }}
                type="Submit"
                classname="submit_btn"
                disabled={FilterValuesCheck(values)}
              />
              &nbsp;&nbsp;
              <CommonButton
                name="Reset"
                onClick={() => {
                  setvalues({ from_date: "", to_date: "" });
                  ResetForm();
                }}
                // style={{ color: "white", backgroundColor: "#0084ff" }}
                classname="reset_btn"
                type="button"
                disabled={FilterValuesCheck(values)}
              />
            </Col>
          </Row>
        </div>
      ) : null}
    </>
  );
}

export default Filterreadingreport;
